module.exports = __webpack_public_path__ + "static/media/caret-down.a8ec368e.svg";